export function checkIsTextTruncated(node) {
    var parentEl = node.parentElement;
    if (!parentEl) {
        return false;
    }
    return parentEl.offsetWidth < parentEl.scrollWidth;
}
